import { deadlineDate } from "./taskSorting";
import { eventTimestamp, validEventTimes } from "./eventTimes";

// Google Calendar's event template opens a draft for the user to review and save.
// https://developers.google.com/workspace/calendar/api/concepts/inviting-attendees-to-events
export const googleCalendarUrl = (task, today = new Date()) => {
  if (!validEventTimes(task)) return null;
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: task.title.trim(),
    details: task.description || "",
  });
  if (task.eventStart && task.eventEnd) {
    const compactTime = (value) => eventTimestamp(value).replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
    params.set("dates", `${compactTime(task.eventStart)}/${compactTime(task.eventEnd)}`);
  } else {
    const date = deadlineDate(task.deadline) || [
      today.getFullYear(),
      String(today.getMonth() + 1).padStart(2, "0"),
      String(today.getDate()).padStart(2, "0"),
    ].join("-");
    const end = new Date(`${date}T00:00:00.000Z`);
    end.setUTCDate(end.getUTCDate() + 1);
    // All-day events use calendar dates, with an exclusive end date.
    const dates = `${date.replace(/-/g, "")}/${end.toISOString().slice(0, 10).replace(/-/g, "")}`;
    params.set("dates", dates);
  }
  return `https://calendar.google.com/calendar/r/eventedit?${params.toString()}`;
};
